(function (m, $) {

    var boxDetails, productTitle;
    m.init = function () {
        $.ajaxSetup({ cache: false });

        boxDetails = m.getData("data-boxprices");

        $("input[name='Option1'], input[name='Option2']").change(m.updateProductDetails);

        m.updateProductDetails();
    };

    m.updateProductDetails = function() {
        var option1 = "00000000-0000-0000-0000-000000000000";
        var option1Name = "";
        var option1Description = "";
        var option1Radio = $("input[type='radio'][name='Option1']:checked");
        if (option1Radio.length > 0) {
            option1 = option1Radio.val();
            option1Name = option1Radio.data("choiceName");
            option1Description = option1Radio.data("choiceDescription");
        }

        var option2 = "00000000-0000-0000-0000-000000000000";
        var option2Name = "";
        var option2Description = "";
        var option2Radio = $("input[type='radio'][name='Option2']:checked");
        if (option2Radio.length > 0) {
            option2 = option2Radio.val();
            option2Name = option2Radio.data("choiceName");
            option2Description = option2Radio.data("choiceDescription");
        }

        var boxPrice = boxDetails[option1][option2]["price"];
        var boxProductID = boxDetails[option1][option2]["product_id"];
        var boxImageUrl = boxDetails[option1][option2]["image_url"];
        var boxProductName = boxDetails[option1][option2]["product_name"];
        var boxProductSupplier = boxDetails[option1][option2]["product_supplier"];

        productTitle = boxDetails["boxName"];
        if (option1Name !== "" && option2Name !== "")
            productTitle = productTitle + " (" + option1Name + ", " + option2Name + ")";
        else if (option1Name !== "" && option2Name === "")
            productTitle = productTitle + " (" + option1Name + ")";
        else if (option1Name === "" && option2Name !== "")
            productTitle = productTitle + " (" + option2Name + ")";

        $(".ux-choice-1-description").html(option1Description);
        $(".ux-choice-2-description").html(option2Description);

        var priceContainer = $(".ux-price");
        var currencySymbol = priceContainer.data("currencySymbol");
        priceContainer.html(currencySymbol + boxPrice.toFixedIntl(2));
        $(".ux-product-image").attr("src", boxImageUrl);

        var trackedAddButton = $(".ux-tracking-addtocart-button, .ux-tracking-manual-addtocart-button");
        if (trackedAddButton) {
            trackedAddButton.attr("tracking-addtocart-price", boxPrice.toFixedIntl(2));
            trackedAddButton.attr("tracking-addtocart-productid", boxProductID);
            trackedAddButton.attr("tracking-addtocart-productname", boxProductName);
            trackedAddButton.attr("tracking-addtocart-productbrand", boxProductSupplier);
        }

        m.updateBoxContents(boxProductID);
    };

    m.updateBoxContents = function (productID) {
        var hubInfoUrl = "/getboxcontents?productID=" + productID + "&weeksToGet=2";

        $.getJSON(hubInfoUrl, function (data) {
            var tableContainer = $(".ux-contents-table");
            tableContainer.empty();

            for (var i = 0; i < data.DeliveryDateCollection.length; i++) {
                var deliveryDate = data.DeliveryDateCollection[i];

                var produceTable = $("<table></table>").addClass("box-list");

                var produceTableHeaderLine = $("<tr></tr>");
                var headers = ["Produce (" + deliveryDate.ProduceDetailCollection.length + " items)", "Grower", "Method", "Location"];
                for (var h = 0; h < headers.length; h++) {
                    produceTableHeaderLine.append($("<th></th>").addClass(h === 1 || h === 3 ? "less-important" : "").text(headers[h]));
                }
                produceTable.append($("<thead></thead>").append(produceTableHeaderLine));
                
                var produceTableContent = $("<tbody></tbody>");
                for (var j = 0; j < deliveryDate.ProduceDetailCollection.length; j++) {
                    var produceDetail = deliveryDate.ProduceDetailCollection[j];
                    var produceTableContentLine = $("<tr></tr>");
                    produceTableContentLine.append($("<td></td>").addClass("important").text(produceDetail.Name));
                    produceTableContentLine.append($("<td></td>").addClass("less-important").text(produceDetail.Grower));
                    produceTableContentLine.append($("<td></td>").text(produceDetail.Method));
                    produceTableContentLine.append($("<td></td>").addClass("less-important").text(produceDetail.Location));
                    produceTableContent.append(produceTableContentLine);
                }
                produceTable.append(produceTableContent);

                var boxContainer = $("<div></div>").addClass("box");
                boxContainer.append($("<h3></h3>").text(productTitle + ": " + deliveryDate.DeliveryDateRange));
                boxContainer.append(produceTable);
                tableContainer.append(boxContainer);
            }
        });
    };

}(window.ooooby = window.ooooby || {}, jQuery));

$(document).ready(function () {
    ooooby.init();
});